export default "__VITE_ASSET__8SCN8gEl__"